import { Link } from "react-router-dom";

const MenuPop = ({ setShowMenu, logout, menuStyle1, menuStyle2, menuStyle3, showMenu, user, hoverWidth, top = null, bottom = null }) => {
    return (<div className='tab-menu shadow px-2'
        style={{
            opacity: showMenu ? 1 : 0,
            pointerEvents: showMenu ? 'all' : 'none',
            position: "fixed",
            transition: '0.5s all',
            transform: showMenu ? 'translateY(0)' : 'translateY(-100%)',
            width: "30vh",
            background: "white",
            borderRadius: 10,
            top: top ?? "auto",
            bottom: bottom ?? "auto",
            right: hoverWidth - 5
        }}>
        {user &&
            <div className='d-flex py-2 mb-2 border-bottom' style={menuStyle1}>
                <img
                    src={user.avatar ?? 'https://ui-avatars.com/api/?background=ec008c&color=ffffff&name=' + user.name}
                    width="30"
                    height="30"
                    className={` d-flex my-auto ${showMenu ? ' bounce' : ''}`}
                    alt=""
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                />
                <p style={{ fontSize: 15 }} className='my-auto  ms-1'>{user.name}</p>
            </div>
        }
        <Link onClick={() => { setShowMenu(); }} to={"/users/myaccount"} className='py-3 border-bottom text-decoration-none text-black' style={menuStyle2} >
            <p style={{ fontSize: 15 }}>My Account</p>
        </Link>
        <div onClick={() => { logout(); setShowMenu(); }} className='py-3' style={menuStyle3}>
            <p style={{ fontSize: 15 }}>Logout</p>
        </div>
    </div>);
}

export default MenuPop;